import React from "react";
import { Icon } from "@iconify/react";
import '../../../styles/Auth/categoryPopup.css';
import { Typography } from "@mui/material";

const ViewProductPopup = ({ data, onClose }) => {
    const availableStock = Array.isArray(data?.mrpHistory) && data.mrpHistory.length > 0
        ? data.mrpHistory.reduce((sum, h) => sum + Number(h.stock || 0), 0)
        : (data?.inStock !== undefined && data?.inStock !== null ? Number(data.inStock) : Number(data?.productStock || data?.stock || 0));

    return (
        <div className="category-detail-overlay">
            <div className="category-detail-modal large">
                <button className="category-detail-close" onClick={onClose}>
                    <Icon icon="solar:close-circle-bold-duotone" width={32} height={32} />
                </button>

                <div className="category-detail-header">
                    <div className="category-detail-image-container">
                        <img
                            src={data?.productImageObject?.uri ? `${process.env.REACT_APP_API_URL}${data.productImageObject.uri}` : "/assets/placeholder.png"}
                            alt={data.title}
                            onError={(e) => { e.target.onerror = null; e.target.src = "/assets/placeholder.png"; }}
                            className="category-detail-img"
                        />
                    </div>
                    <Typography variant="h4" className="category-detail-title">
                        {data.title}
                    </Typography>
                    <div className="product-category-badge">
                        <Icon icon="solar:tag-bold-duotone" width={14} />
                        <span>Product Detail</span>
                    </div>
                </div>

                <div className="category-detail-content">
                    <div className="category-detail-stats grid-2">
                        <div className="stat-card">
                            <Icon icon="solar:box-bold-duotone" className="stat-icon" />
                            <div className="stat-info">
                                <span className="stat-label">Available Stock</span>
                                <span className="stat-value">{availableStock} Units</span>
                            </div>
                        </div>
                        <div className="stat-card">
                            <Icon icon="solar:shield-check-bold-duotone" className="stat-icon" />
                            <div className="stat-info">
                                <span className="stat-label">Product Status</span>
                                <span className={`stat-value ${data.productStatus === 'Active' ? 'active' : 'inactive'}`}>
                                    {data.productStatus || 'Active'}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="price-summary-card">
                        <span className="price-summary-title">Financial & Pricing Summary</span>
                        <div className="price-grid">
                            <div className="price-item">
                                <span className="price-label">Current Selling Price (MRP)</span>
                                <span className="price-value highlight">₹{data.sellingPrice || 0}</span>
                            </div>
                            <div className="price-item">
                                <span className="price-label">Tax Rate</span>
                                <span className="price-value">{data.gstPercentage || 0}%</span>
                            </div>
                        </div>
                        {Array.isArray(data.mrpHistory) && data.mrpHistory.length > 0 && (
                            <div style={{ marginTop: '15px' }}>
                                <span className="price-summary-title" style={{ fontSize: '13px' }}>MRP History & Stock Breakdown</span>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '8px' }}>
                                    {data.mrpHistory.map((h, i) => (
                                        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', background: '#f8f9fa', padding: '6px 12px', borderRadius: '4px' }}>
                                            <span>MRP: <strong>₹{h.mrp}</strong></span>
                                            <span>Batch Stock: <strong>{h.stock ?? 0} units</strong></span>
                                            <span style={{ color: '#777' }}>Date: {new Date(h.effectiveDate).toLocaleDateString()}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="category-detail-footer">
                    <button className="category-detail-action-btn" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewProductPopup;

